// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3eHM2","vLegacy":"SelectSecondary_vLegacy__A_KNs","error":"SelectSecondary_error__mibM7","disabled":"SelectSecondary_disabled__TE77T"};